export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const UPDATE_TO_CART = "UPDATE_TO_CART";
export const EMPTY_CART = "EMPTY_CART";
export const SET_INCREMENT = "SET_INCREMENT";
export const SET_DECREMENT = "SET_DECREMENT";
export const CART_TOTAL_ITEM = "CART_TOTAL_ITEM";
export const CART_TOTAL_PRICE = "CART_TOTAL_PRICE";

export const GET_COMPANIES = "GET_COMPANIES";

export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_CODE = "GET_PRODUCT_CODE";
export const SET_LOADING = "SET_LOADING";
export const COMP_ERROR = "COMP_ERROR";

export const ADD_ORDER= 'ADD_ORDER';
export const UPDATE_ORDER= 'UPDATE_ORDER';
